module.exports = __webpack_public_path__ + "static/media/it-IT.3fd395a6.md";